<template>
  <div class="Policy-content-item" :class="{ 'Policy-content-item-mobile': isMobile }">
    <div class="pic" :style="{ backgroundImage: `url(${data.icon})` }"></div>
    <div class="names" :style="{ backgroundColor: `${data.color}` }">{{ data.name }}</div>
  </div>
</template>
<script>
  export default {
    name: 'PolicyContentItem',
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
<style lang="scss" scoped>
  .Policy-content-item {
    display: flex;
    align-items: center;
    margin: 0 0.135rem;
    border-radius: 0.03rem;
    width: 3.33rem;
    height: 3.76rem;
    background: #fff;
    box-shadow: 0 0.03rem 0.16rem 0.03rem rgb(226 226 226 / 59%);
    flex-direction: column;
    padding-top: 0.44rem;
    justify-content: space-between;
  }

  .pic {
    width: 1.23rem;
    height: 1.23rem;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .names {
    width: 100%;
    height: 1.73rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.27rem;
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.37rem;
    letter-spacing: 1px;
    border-top-right-radius: 2.7rem;
    border-top-left-radius: 2.7rem;
  }
  .Policy-content-item-mobile {
    margin: 0;
    border-radius: 0.07rem;
    width: 8.29rem;
    height: 9.36rem;
    background: #fff;
    box-shadow: 0 0.1rem 0.41rem 0.1rem rgba(226, 226, 226, 0.59);
    flex-direction: column;
    padding-top: 1.08rem;
    margin-top: .67rem;
    .pic {
      width: 3.12rem;
      height: 3.12rem;
      background-repeat: no-repeat;
      background-size: 100%;
    }

    .names {
      width: 100%;
      height: 4.31rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.72rem;
      line-height: 1.02rem;
      border-top-right-radius: 4rem;
      border-top-left-radius: 4rem;
    }
  }
</style>
